import { CircularProgress, Typography, Box } from '@mui/material'
import React from 'react'

/**
 * A loader that accepts text that is displayed beneath it
 * @param props
 * @returns {*}
 */
export default function CustomCircularProgress({ text }) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <CircularProgress />
            <Typography
                sx={{ margin: '15px 0' }}
                variant="subtitle2"
                color={'textSecondary'}
            >
                {' '}
                {text}{' '}
            </Typography>
        </Box>
    )
}
